module.exports = __webpack_public_path__ + "img/i2.27b1a069.jpg";